module.exports = __webpack_public_path__ + "img/black.bd053d18.png";